module.exports = __webpack_public_path__ + "img/president-polk.1cf62c38.png";